<template>
  <div class="desempenho-cartaz-page">
    <div v-if="erro" class="desempenho-cartaz-erro">
      {{ erro }}
    </div>
    <CartazPreview v-else :dados="dadosCartaz" />
  </div>
</template>

<script>
import CartazPreview from './CartazPreview.vue'

export default {
  name: 'DesempenhoCartaz',

  components: {
    CartazPreview,
  },

  data() {
    return {
      erro: '',
    }
  },

  computed: {
    dadosCartaz() {
      return { ...this.$route.query }
    },
  },
}
</script>

<style scoped>
.desempenho-cartaz-page {
  min-height: 100vh;
}

.desempenho-cartaz-erro {
  padding: 24px;
  text-align: center;
  color: #a11818;
  font-family: Arial, Helvetica, sans-serif;
}
</style>
